<div [formGroup]="formGroup" *ngIf="formGroup">
  <div class="row row--center hidden">
    <div class="col">
      <mat-form-field [hideRequiredMarker]="true" class="col__ mb-0050">
        <mat-label>Email Address</mat-label>
        <input matInput type="email" placeholder="name@domain.com" data-test-id="emailAddressInput"
            formControlName="email" autocomplete="off" appAutoFocus>
        <app-input-error *ngIf="formGroup.controls.email" [formControlItem]="formGroup.controls.email">
        </app-input-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row row--email-confirm hidden mb-0050">
    <mat-radio-group formControlName="emailType">
      <mat-radio-button [value]="'home'" [disableRipple]="true">
        Home
      </mat-radio-button>
      <mat-radio-button [value]="'work'" [disableRipple]="true">
        Work
      </mat-radio-button>
    </mat-radio-group>

    <div class="d-block d-inline-block--sm w-100 w-auto--sm mb-0050 mb-0--ps mr-0100">
      <mat-checkbox formControlName="verified"
                    disableRipple>Confirmed</mat-checkbox>
    </div>

    <div class="d-block d-inline-block--sm">
      <mat-checkbox formControlName="subscribed"
                    disableRipple>Subscribed</mat-checkbox>
    </div>
  </div>
</div>
